export class Region {
    key! : string;
    name! : string;
    country! : string;
    type! : string;
}